import React from 'react';

import { useIntl } from 'react-intl';

import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar, TOOLBAR_BUTTON_TEST_ID } from '@atlaskit/editor-common/toolbar';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { isOfflineMode } from '@atlaskit/editor-plugin-connectivity';
import { ToolbarButton, ToolbarTooltip, ImageIcon } from '@atlaskit/editor-toolbar';

import type { InsertBlockPlugin } from '../../insertBlockPluginType';

type ImageButtonProps = {
	api?: ExtractInjectionAPI<InsertBlockPlugin>;
};

export const ImageButton = ({ api }: ImageButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const { connectivityMode, imageUploadEnabled } = useSharedPluginStateWithSelector(
		api,
		['connectivity', 'imageUpload'],
		(states) => ({
			connectivityMode: states.connectivityState?.mode,
			imageUploadEnabled: states.imageUploadState?.enabled,
		}),
	);

	const { editorView } = useEditorToolbar();

	const isOffline = isOfflineMode(connectivityMode);

	const onClick = () => {
		if (editorView) {
			const { state, dispatch } = editorView;
			api?.imageUpload?.actions.startUpload()(state, dispatch);
		}
	};
	return (
		<ToolbarTooltip content={formatMessage(messages.image)}>
			<ToolbarButton
				iconBefore={<ImageIcon label={formatMessage(messages.image)} size="small" />}
				onClick={onClick}
				isDisabled={!imageUploadEnabled || isOffline}
				testId={TOOLBAR_BUTTON_TEST_ID.IMAGE}
			/>
		</ToolbarTooltip>
	);
};
